import { render, staticRenderFns } from "./NachbestellungProdukte.vue?vue&type=template&id=0cb93fda"
import script from "./NachbestellungProdukte.vue?vue&type=script&lang=ts"
export * from "./NachbestellungProdukte.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports